import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=bbe69b74&"
import script from "./TextArea.vue?vue&type=script&lang=ts&"
export * from "./TextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe69b74')) {
      api.createRecord('bbe69b74', component.options)
    } else {
      api.reload('bbe69b74', component.options)
    }
    module.hot.accept("./TextArea.vue?vue&type=template&id=bbe69b74&", function () {
      api.rerender('bbe69b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/TextArea.vue"
export default component.exports